document.addEventListener("DOMContentLoaded", () => {
  // Target specific structural elements for luxury reveal
  const revealElements = document.querySelectorAll('.reveal-up, .kannaki-reveal, .kannaki-showcase-card, .kannaki-category-tile, .kannaki-grid-matrix > div');
  
  revealElements.forEach(el => {
    if (!el.classList.contains('reveal-up') && !el.classList.contains('kannaki-reveal')) {
      el.classList.add('kannaki-reveal');
    }
  });

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Subtle staggered entrance
        setTimeout(() => {
          entry.target.classList.add('is-visible', 'animate-fade-up');
        }, 60);
        obs.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.05
  });

  document.querySelectorAll('.reveal-up, .kannaki-reveal, .animate-fade-up').forEach(el => observer.observe(el));
});
